function freqToTimeConst(freq: string): 5 | 6 | 7 | undefined {
	switch (freq) {
		case 'day':
			return 5;
		case 'week':
			return 6;
		case 'month':
			return 7;
		default:
			return undefined;
	}
}

export default {};

export { freqToTimeConst };
